import type { RegionDomain } from '@mathflat/domain/@entities/Region/domain'
import { makeAutoObservable } from 'mobx'

export interface RegionTreeNode {
  id: string
  sido: string | null
  sigungu: string | null
  name: string
  children: RegionTreeNode[] | null
  setChildren(children: RegionTreeNode[]): void
}

export class SidoTreeNode implements RegionTreeNode {
  private _code: string
  private _sidoName: string
  private _sigunguName: string | null
  private _type: RegionDomain.RegionType
  private _children: RegionTreeNode[] = []

  get id(): string {
    return this._code
  }

  get name(): string {
    return this._sidoName
  }

  get sido(): string {
    return this._sidoName
  }

  get sigungu(): string | null {
    return this._sigunguName
  }

  get children(): RegionTreeNode[] | null {
    return [...this._children]
  }

  constructor(sido: RegionDomain.Region) {
    makeAutoObservable(this)

    this._code = sido.code
    this._sidoName = sido.sidoName
    this._sigunguName = sido.sigunguName
    this._type = sido.type
  }

  setChildren(children: RegionTreeNode[]) {
    this._children = children
  }
}

export class SigunguTreeNode implements RegionTreeNode {
  private _code: string
  private _sidoName: string
  private _sigunguName: string
  private _type: RegionDomain.RegionType
  private _children: RegionTreeNode[] = []

  get id(): string {
    return this._code
  }

  get name(): string {
    return this._sigunguName
  }

  get sido(): string | null {
    return this._sidoName
  }

  get sigungu(): string | null {
    return this._sigunguName
  }

  get children(): RegionTreeNode[] | null {
    return [...this._children]
  }

  constructor(sido: RegionDomain.Region) {
    makeAutoObservable(this)

    this._code = sido.code
    this._sidoName = sido.sidoName
    this._sigunguName = sido.sigunguName!
    this._type = sido.type
  }

  setChildren(children: RegionTreeNode[]) {
    this._children = children
  }
}
